(() => {
  const sections = document.querySelectorAll('[data-figma-blog-article]');

  sections.forEach((section) => {
    const content = section.querySelector('[data-blog-article-content]');
    const tocList = section.querySelector('[data-blog-article-toc-list]');

    if (content) {
      const blocks = 'h1,h2,h3,h4,h5,h6,p,li,blockquote,figcaption,pre,td,th';
      const excluded = 'a,button,input,select,textarea,summary,script,style,iframe,video,audio,[hidden],[aria-hidden="true"],[data-content-reading-stop]';
      const addReadingStops = (element) => {
        if (element.matches(excluded)) return;
        if (element.matches(blocks) && !element.querySelector(blocks)) {
          if (element.textContent.trim() && !element.hasAttribute('tabindex')) {
            element.tabIndex = 0;
          }
          return;
        }
        Array.from(element.childNodes).forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            const stop = document.createElement('span');
            stop.tabIndex = 0;
            stop.dataset.contentReadingStop = '';
            node.replaceWith(stop);
            stop.appendChild(node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            addReadingStops(node);
          }
        });
      };
      addReadingStops(content);
    }

    if (content && tocList && tocList.children.length === 0) {
      const headings = Array.from(content.querySelectorAll('h2'));
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const slug = heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
          heading.id = slug || `article-heading-${index + 1}`;
        }

        const item = document.createElement('li');
        item.className = 'figma-blog-article__toc-item';

        const link = document.createElement('a');
        link.className = 'figma-blog-article__toc-link';
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', () => {
          heading.focus({ preventScroll: true });
        });

        item.appendChild(link);
        tocList.appendChild(item);
      });
    }

    section.querySelectorAll('[data-seo-sidebar-cta]').forEach((callout) => {
      if (callout.dataset.trackingBound === 'true') return;
      callout.dataset.trackingBound = 'true';

      const details = {
        cta_id: callout.dataset.ctaId,
        article_handle: callout.dataset.articleHandle,
        cta_location: callout.dataset.ctaLocation,
        destination_path: callout.dataset.ctaDestination,
      };
      const pushEvent = (name, extra = {}) => {
        window.dataLayer = window.dataLayer || [];
        const payload = { ...details, ...extra };
        window.dataLayer.push({ event: name, ...payload });
        window.StikwoodArticleCtaGa4?.track(name, payload);
      };

      let viewTimer;
      let viewTracked = false;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (viewTracked) return;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              if (!viewTimer) {
                viewTimer = window.setTimeout(() => {
                  viewTracked = true;
                  callout.dataset.viewTracked = 'true';
                  pushEvent('seo_sidebar_cta_view');
                  observer.disconnect();
                }, 1000);
              }
            } else if (viewTimer) {
              window.clearTimeout(viewTimer);
              viewTimer = undefined;
            }
          });
        },
        { threshold: [0.5] },
      );
      observer.observe(callout);

      callout.querySelectorAll('[data-seo-sidebar-cta-link]').forEach((link) => {
        link.addEventListener('click', () => {
          pushEvent('seo_sidebar_cta_click', {
            cta_element: link.dataset.seoSidebarCtaLink,
          });
        });
      });
    });
  });
})();
